import { KONNYU_NEGYKEREKU, MOTOR, SEGEDMOTOR, SZGK } from '../../modules/Gepjarmu';

export const EUROTAX_TYPE_CAR = 0;
export const EUROTAX_TYPE_MOTOR = 1;

export const eurotaxToVehicleType = (eurotaxType) => {
    switch (eurotaxType) {
        case EUROTAX_TYPE_MOTOR:
            return MOTOR;
        default:
            return SZGK;
    }
};

export const vehicleToEurotaxType = (type) => {
    switch (type) {
        case MOTOR:
        case SEGEDMOTOR:
        case KONNYU_NEGYKEREKU:
            return EUROTAX_TYPE_MOTOR;
        default:
            return EUROTAX_TYPE_CAR;
    }
};

export const allExtrasInCarList = (carList) => {
    const allExtras = [];
    const alreadyAdded = (record) => {
        let added = false;
        allExtras.forEach((extra) => {
            if (record.eq_code === extra.eq_code) {
                added = true;
            }
        });
        return added;
    };

    carList.forEach((car) => {
        (car.extras || []).forEach((carsExtra) => {
            if (!alreadyAdded(carsExtra)) {
                allExtras.push({
                    eq_code: carsExtra.eq_code,
                    name: carsExtra.name,
                    short_name: carsExtra.short_name,
                });
            }
        });
    });
    return allExtras;
};

export const findSpecialExtras = (cars) => {
    const allExtras = allExtrasInCarList(cars);
    const carsInPool = cars.length;
    if (carsInPool > 0) {
        const specialExtras = [];
        allExtras.forEach((extra) => {
            let carHasThisExtra = 0;
            cars.forEach((car) => {
                (car.extras || []).forEach((carExtra) => {
                    if (extra.eq_code === carExtra.eq_code) {
                        carHasThisExtra += 1;
                    }
                });
            });
            if (carHasThisExtra < carsInPool) {
                specialExtras.push({
                    eq_code: extra.eq_code,
                    name: extra.name,
                    short_name: extra.short_name,
                });
            }
        });
        return specialExtras;
    }
    return [];
};
